import { combineReducers } from "redux";

// Authentication
import authentication from "./authentication/reducer";
import settings from "./settings/reducer";
import contacts from "./contacts/reducer";
import services from "./services/reducer";
import works from "./works/reducer";
import clients from "./clients/reducer";
import categories from "./categories/reducer";
import subscribers from "./subscribers/reducer";
import admins from "./admins/reducer";
import socialLinks from "./socialLinks/reducer";

const rootReducer = combineReducers({
  authentication,
  settings,
  contacts,
  services,
  works,
  clients,
  categories,
  subscribers,
  admins,
  socialLinks,
});

export default rootReducer;
